import React from "react";
import * as PIXI from 'pixi.js';
import GameBoard from "../gameplay/view/GameBoard";
import bg from '../images/gameplay/gameboard.png'
import {
    ELECTRO_TYPE, INFRA_TYPE, LOCO_TYPE, MODER_ROLE_KEY,

} from "../constants/Constants";
import * as TWEEN from "@tweenjs/tween.js";
import BalanceWindow from "./InGameUI/Windows/BalanceWindow";
import GameData from "../gameplay/model/GameData";
import InvestWindow from "./InGameUI/Invest/InvestWindow";
import StationPanel from "./InGameUI/Panels/StationPanel";
import StationPanel_RepairCard from "./InGameUI/Panels/StationPanel_RepairCard";
import GameTopPanel from "./InGameUI/GameTopPanel";
import GameBottomPanel from "./InGameUI/GameBottomPanel";
import SortCarTrainWindow from "./InGameUI/SortCarTrains/SortCarTrainWindow";
import StationGameCard from "../gameplay/model/cards/StationGameCard";
import PathGameCard from "../gameplay/model/cards/PathGameCard";
import {SecurityGameCard} from "../gameplay/model/cards/SecurityGameCard";
import PathGameCardUI from "./InGameUI/GameCards/PathGameCardUI";
import StationGameCardUI from "./InGameUI/GameCards/StationGameCardUI";
import SecurityGameCardUI from "./InGameUI/GameCards/SecurityGameCardUI";
import OrdersWindow from "./InGameUI/Orders/OrdersWindow";
import RepairWindowUI from "./InGameUI/Repair/RepairWindowUI";
import StationPanel_DispetcherCard from "./InGameUI/Panels/StationPanel_DispetcherCard";
import PathCard from "./InGameUI/GeneralCards/PathCard";
import TrainCreateWindow from "./InGameUI/Train/TrainCreateWindow";
import {DndProvider} from "react-dnd";
import {HTML5Backend} from "react-dnd-html5-backend";
import GameController from "../gameplay/controllers/GameController";
import LocoGameCard from "../gameplay/model/cards/LocoGameCard";
import LocoGameCardUI from "./InGameUI/GameCards/LocoGameCardUI";
import agent from "../agent";
import RuntimeGameData from "../gameplay/model/RuntimeGameData";
import Loader from "./Loader";
import {LoaderObject} from "../LoaderDummy";
import TendersPanel from "./InGameUI/Tenders/TendersPanel";
import GamePopup from "./InGameUI/Windows/GamePopup";
import * as GameStyleUI from "./InGameUI/GameStyleUI";
import {PATH_CARD_POSITIONS} from "./InGameUI/GameStyleUI";
import PathDetailsWindow from "./InGameUI/PathDetails/PathDetailsWindow";
import StatisticsWindow from "./InGameUI/Windows/StatisticsWindow";
import GainsLossesReportWindow from "./InGameUI/Windows/GainsLossesReportWindow";
import ContractsWindow from "./InGameUI/Contracts/ContractsWindow";
import StationInformation from "./InGameUI/Windows/StationInformation";
import UtilsFunctions from "../utils/UtilsFunctions";
import TrainCarRentBackWindow from "./InGameUI/TrainCarRent/TrainCarRentBackWindow";

const spriteAliases = [
    ['bg', bg]
];

class Gameplay extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isShowBalance: false,
            isShowTenders: false,
            isShowInvest: false,
            isShowRentTrainCarAction: false,
            isShowStatistics: false,
            isShowGainsLosses: false,
            isShowStationInformation: false,
            currentCards: [],
            SortStageStation: null,
            PathDetailsInfo: null,
            repairShop: null,
            isShowOrders: false,
            isShowContracts: false,
            trainCreateStation: null,
            currentStationPopup: null
        }
        LoaderObject.setView(this);
        LoaderObject.setLoading();
        this.gameDataHeartbeat = null;
        this.lastState = 0
        this.lastDataChange = null;

        this.isNotAdmin = agent.user.role !== MODER_ROLE_KEY;
    }

    readGameData(onFinish) {
        agent.GamePlay.getGameData(this.props.teamID, (response) => {
            LoaderObject.freeLoading();
            GameData.CurrentGame.setData(response, this.props.teamID);

            if (onFinish) {
                onFinish();
            }
            if (this.lastState !== GameData.CurrentGame.state) {
                this.lastState = GameData.CurrentGame.state;
                this.updateStateChange();
            }
            this.forceUpdate();
        })
    }

    checkGamedataStatus() {
        agent.GamePlay.gameDataStatus(this.props.teamID, (response) => {
            if (this.lastDataChange === null || this.lastDataChange.last_changed !== response.last_changed) {
                this.readGameData();
            }
            this.lastDataChange = response;
        });
    }

    updateStateChange() {
        this.hideBalance();
        this.hideInvest();
        this.hideSort(true);
        this.hideRepair();
        this.hideTrainCreate();
        this.setState({
            isShowInvest: GameData.CurrentGame.state === 0
                && this.isNotAdmin
                && GameData.CurrentGame.year !== 0
                && !GameData.CurrentGame.isInvestComplete,
            isShowRentTrainCarAction: GameData.CurrentGame.state === 1
                && !GameData.CurrentGame.isRentTrainCarActionComplete
                && GameData.CurrentGame.isShouldShowRentBackWindow(),
            isShowBalance: GameData.CurrentGame.state === 0 && this.isNotAdmin,
            isShowGainsLosses: GameData.CurrentGame.state === 0 && GameData.CurrentGame.year !== 0 && this.isNotAdmin,
            isShowTenders: this.isNotAdmin && GameData.CurrentGame.state === 0 && GameData.CurrentGame.year !== 0,
            currentCards: GameData.CurrentGame.getCurrentCards(),
            PathDetailsInfo: null,
            isShowStatistics: false
        });

        if (this.isNotAdmin && !localStorage.getItem("tenderResultsShown")) {
            let game = GameData.CurrentGame;
            if (game.state === 1 && game.year > 0 && game.tenders) {
                let allTendersParticipatedIn = game.tenders.filter(el => el.isPlacedOrder);
                let won = [];
                for (let tender of allTendersParticipatedIn) {
                    let theTenderOrder = game.thisYearOrder.filter(el => el.code === tender.order.code);
                    if (theTenderOrder.length) {
                        won.push(`${theTenderOrder[0].code} на сумму ${UtilsFunctions.toPrettyNumber(theTenderOrder[0].cost * theTenderOrder[0].weight)}₽`);
                    }
                }

                let res = "<p>Поздравляем! Вы выиграли тендер";
                if (won.length > 0) {
                    if (won.length === 1) {
                        res += ` ${won[0]}</p>`;
                    } else {
                        res += `ы:</p> <ul><li>${won.join("</li><li>")}</li></ul>`;
                    }

                    res += "<p>Чтобы узнать о заказе больше – зайдите в Заказы</p>";
                    alert(res, false, true);
                    localStorage.setItem("tenderResultsShown", "1");
                }
            }
        }
    }

    componentDidMount() {
        this.app = new PIXI.Application({
            width: this.props.width,
            height: this.props.height,
            sharedLoader: true,
            sharedTicker: true,
            antialias: true,
            backgroundColor: 0xE5E5E5
        });
        console.log(this.app)
        PIXI.Ticker.shared.start();
        PIXI.settings.SCALE_MODE = PIXI.SCALE_MODES.NEAREST;
        let loader = PIXI.Loader.shared;
        this.width = this.props.width;
        this.height = this.props.height;
        for (let i = 0; i < spriteAliases.length; i++) {
            if (!loader.resources[spriteAliases[i][0]]) {
                loader.add(spriteAliases[i][0], spriteAliases[i][1]);
            }
        }
        PIXI.Ticker.shared.add(() => {
            TWEEN.update();
        });
        this.readGameData(() => {
            this.lastState = GameData.CurrentGame.state;
            this.updateStateChange();
            let playGround = document.getElementById('pxrender');
            playGround.appendChild(this.app.view);

            loader.onComplete.add(this.texturesLoadComplete.bind(this));
            loader.load();

            this.gameDataHeartbeat = setInterval(this.checkGamedataStatus.bind(this), 2000);
            GameData.CurrentGame.onDataUpdated = () => {
                this.forceUpdate()
            };
        });

        window.GameData = GameData;
        window.RuntimeGameData = RuntimeGameData;
    }

    componentWillUnmount() {
        RuntimeGameData.CurrentGame.clear();
        PIXI.Ticker.shared.stop();
        clearInterval(this.gameDataHeartbeat);
        localStorage.removeItem("notClientMasterMessage");
    }

    texturesLoadComplete() {
        let gameBoard = new GameBoard(this.app.stage, this.width, this.height);
        this.app.stage.position.set(this.width / 2, this.height / 2);
        this.app.stage.addChild(gameBoard.container);
        gameBoard.container.position.x = 0;
    }

    hideStationInformation() {
        this.setState({
            isShowStationInformation: false
        })
    }

    hideStatistics() {
        this.setState({
            isShowStatistics: false
        });
    }

    hideGainsLosses() {
        this.setState({
            isShowGainsLosses: false
        });
    }

    hideBalance() {
        this.setState({
            isShowBalance: false
        })
    }

    hideInvest() {
        this.setState({
            isShowInvest: false
        });
    }
    hideTrainCarRentBack() {
        this.setState({
            isShowRentTrainCarAction: false
        });
    }
    hideTenders() {
        this.setState({
            isShowTenders: false
        });
    }

    hideCards() {
        let currentCards = this.state.currentCards.shift();
        this.setState({
            currentCard: currentCards
        });
    }

    hideSort(isAuto) {
        // isAuto – по клику будет SyntheticEvent, но при автозакрытии – true
        // сохраняем данные только при клике

        if (agent.user.role === "player" && typeof isAuto !== "boolean") {
            let clientsIndex = UtilsFunctions.getRoleNameIndex("Зам. по работе с клиентами");
            if (UtilsFunctions.playerHasRole(clientsIndex)) {
                agent.GamePlay.sortTrainSetState(this.props.teamID, RuntimeGameData.CurrentGame.getSortTrainData(), () => {});
            }
        }

        RuntimeGameData.CurrentGame.clear();
        this.setState({
            SortStageStation: null
        });
    }

    hideTrainCreate() {
        this.setState({
            trainCreateStation: null
        });
    }

    hideRepair() {
        this.setState({
            repairShop: null
        });
    }

    hideOrders() {
        this.setState({
            isShowOrders: false
        });
    }

    hideContracts() {
        this.setState({
            isShowContracts: false
        })
    }

    showSortCard(station) {
        this.setState({
            SortStageStation: station,
            currentStationPopup: null
        })
    }

    showTrainCreate(station) {
        this.setState({
            trainCreateStation: station,
            currentStationPopup: null
        });
    }

    showRepairCard(repairShop) {
        this.setState({
            repairShop: repairShop,
            currentStationPopup: null
        })
    }

    showPathDetails(path) {
        this.setState({
            PathDetailsInfo: path.id,
            currentStationPopup: null
        });
    }

    showStationInfo(station) {
        this.setState({
            isShowStationInformation: true,
            currentStation: station,
            currentStationPopup: null,
        })
    }

    getCards() {
        let card = this.state.currentCards[0];

        if (card instanceof StationGameCard) {
            return <StationGameCardUI
                card={card}
                width={this.props.width}
                height={this.props.height}
                onHide={this.hideCards.bind(this)}
            />
        }
        if (card instanceof PathGameCard) {
            return <PathGameCardUI
                card={card}
                width={this.props.width}
                height={this.props.height}
                onHide={this.hideCards.bind(this)}
            />
        }
        if (card instanceof SecurityGameCard) {
            return <SecurityGameCardUI
                card={card}
                width={this.props.width}
                height={this.props.height}
                onHide={this.hideCards.bind(this)}
            />
        }
        if (card instanceof LocoGameCard) {
            return <LocoGameCardUI
                card={card}
                width={this.props.width}
                height={this.props.height}
                onHide={this.hideCards.bind(this)}
            />
        }
        return "";
    }

    getSortStagePopup(station) {
        return <SortCarTrainWindow
            width={this.props.width}
            height={this.props.height}
            station={station}
            onHide={this.hideSort.bind(this)}
        />
    }

    getTrainCreatePopup(station) {
        return <TrainCreateWindow
            width={this.props.width}
            height={this.props.height}
            station={station}
            teamID={this.props.teamID}
            onHide={this.hideTrainCreate.bind(this)}
        />
    }

    getRepairShopPopup(repairShop) {
        return <RepairWindowUI
            width={this.props.width}
            height={this.props.height}
            teamID={this.props.teamID}
            repairShop={repairShop}
            onHide={this.hideRepair.bind(this)}
        />
    }

    getOrdersWindow() {
        let mainStyle = {
            position: "absolute",
            right: "30px",
            bottom: "80px"
        }
        return <div style={mainStyle}>
            <OrdersWindow onHide={this.hideOrders.bind(this)}/>
        </div>
    }

    getContractsWindow() {
        let mainStyle = {
            position: "absolute",
            right: "30px",
            bottom: "80px"
        }
        return <div style={mainStyle}>
            <ContractsWindow onHide={this.hideContracts.bind(this)}/>
        </div>
    }

    initTopPanel() {
        let mainStyle = {
            position: "absolute",
            left: "20px",
            top: "20px"
        }
        return <div style={mainStyle}>
            <GameTopPanel currentRole={this.props.currentRole} parent={this} teamID={this.props.teamID}/>
        </div>
    }

    initBottomPanel() {
        let mainStyle = {
            position: "absolute",
            left: "0",
            bottom: "0"
        }
        return <div style={mainStyle}>
            <GameBottomPanel width={this.props.width} teamID={this.props.teamID} parent={this} onOrdersClick={() => {
                this.setState({
                    isShowOrders: !this.state.isShowOrders,
                    isShowContracts: false,
                    currentStationPopup: null
                })
            }} onStatisticsClick={() => {
                this.setState({
                    isShowStatistics: !this.state.isShowStatistics,
                    currentStationPopup: null,
                })
            }} onContractsClick={() => {
                this.setState({
                    isShowContracts: !this.state.isShowContracts,
                    isShowOrders: false,
                    currentStationPopup: null
                })
            }} canShow={this.state.currentStationPopup === 'credit'} updatePopup={this.onStationPopup.bind(this)}/>
        </div>
    }

    onStationPopup(id) {
        this.setState({
            currentStationPopup: id
        })
    }

    initStationsUI() {
        let mainStyle = {
            display: "flex",
            justifyContent: "space-between"
        }
        let containerStyle = {
            position: "absolute",
            top: "15px",
            marginLeft: "20px",
            marginRight: "20px",
            marginTop: "65px",
            marginBottom: "110px",
            width: `${this.props.width - 40}px`,
            height: `${this.props.height - 170}px`,
            ...mainStyle,
            flexDirection: "column"
        }
        return <div style={containerStyle}>
            <div style={mainStyle}>
                <StationPanel
                    canShow={this.state.currentStationPopup === 2}
                    updatePopup={this.onStationPopup.bind(this)}
                    teamID={this.props.teamID}
                    station={GameData.CurrentGame.getStationByID(2)}
                    onSortButton={this.showSortCard.bind(this)}
                    onCreateTrainButton={this.showTrainCreate.bind(this)}
                    openStationInformation={this.showStationInfo.bind(this)}
                />
                <StationPanel
                    canShow={this.state.currentStationPopup === 1}
                    updatePopup={this.onStationPopup.bind(this)}
                    teamID={this.props.teamID}
                    station={GameData.CurrentGame.getStationByID(1)}
                    onRepairButton={this.showRepairCard.bind(this)}
                    repairShop={GameData.CurrentGame.getRepairShopByType(ELECTRO_TYPE)}
                    onSortButton={this.showSortCard.bind(this)}
                    onCreateTrainButton={this.showTrainCreate.bind(this)}
                    openStationInformation={this.showStationInfo.bind(this)}
                />
            </div>
            <div style={{...mainStyle, alignItems: "flex-end"}}>
                <StationPanel
                    canShow={this.state.currentStationPopup === 3}
                    updatePopup={this.onStationPopup.bind(this)}
                    teamID={this.props.teamID}
                    station={GameData.CurrentGame.getStationByID(3)}
                    repairShop={GameData.CurrentGame.getRepairShopByType(LOCO_TYPE)}
                    onSortButton={this.showSortCard.bind(this)}
                    onRepairButton={this.showRepairCard.bind(this)}
                    onCreateTrainButton={this.showTrainCreate.bind(this)}
                    openStationInformation={this.showStationInfo.bind(this)}
                />
                <div style={{
                    width: "496px",
                    height: "110px",
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gridTemplateRows: "1fr 1fr",
                    gap: "10px",
                    position: "absolute",
                    "left": "calc(50% - 248px)"
                }}>
                    <StationPanel_DispetcherCard
                    canShow={this.state.currentStationPopup === 5}
                    updatePopup={this.onStationPopup.bind(this)} teamID={this.props.teamID}/>
                    <StationPanel_RepairCard
                    canShow={this.state.currentStationPopup === 'electro'}
                    updatePopup={this.onStationPopup.bind(this)} teamID={this.props.teamID} type={ELECTRO_TYPE}/>
                    <StationPanel_RepairCard
                    canShow={this.state.currentStationPopup === 'infra'}
                    updatePopup={this.onStationPopup.bind(this)} teamID={this.props.teamID} type={INFRA_TYPE}/>
                    <StationPanel_RepairCard
                    canShow={this.state.currentStationPopup === 'loco'}
                    updatePopup={this.onStationPopup.bind(this)} teamID={this.props.teamID} type={LOCO_TYPE}/>
                </div>
                <StationPanel
                    canShow={this.state.currentStationPopup === 0}
                    updatePopup={this.onStationPopup.bind(this)}
                    teamID={this.props.teamID}
                    station={GameData.CurrentGame.getStationByID(0)}
                    onSortButton={this.showSortCard.bind(this)}
                    onCreateTrainButton={this.showTrainCreate.bind(this)}
                    openStationInformation={this.showStationInfo.bind(this)}
                />
            </div>
        </div>
    }

    initPaths() {
        let pathCards = [];
        for (let i = 1; i <= 7; i++) {
            let path = GameData.CurrentGame.getPathByID(i);
            pathCards.push(<PathCard
                key={i}
                parent={this}
                path={path}
                x={PATH_CARD_POSITIONS[i - 1].x}
                y={PATH_CARD_POSITIONS[i - 1].y}
                teamID={this.props.teamID}
                facingLeft={i % 2 === 0 || i === 5}
                showPathDetails={() => {
                    this.showPathDetails(path);
                }}
                onDrop={(item) => {
                    // Дроп только если блока ещё нет на пути (фикс дублирования)
                    if (!GameData.CurrentGame.isTrainOnAnyPath(item.data.id)) {
                        GameController.setTrainToPath(this.props.teamID, i, item.data.id);
                        this.forceUpdate();
                    }
                }}/>);
        }

        return pathCards;
    }

    render() {
        if (!GameData.CurrentGame.isInited) return "";
        let balancePopup = this.state.isShowBalance ? <BalanceWindow
            width={this.props.width}
            height={this.props.height}
            isEditable={GameData.CurrentGame.year === 0}
            teamID={this.props.teamID}
            onHide={this.hideBalance.bind(this)}/> : "";
        let investPopup = <InvestWindow
            isShow={this.state.isShowInvest}
            width={this.props.width}
            height={this.props.height}
            teamID={this.props.teamID}
            onHide={this.hideInvest.bind(this)}/>;
        let trainCarRentBackWindow = <TrainCarRentBackWindow
            isShow={this.state.isShowRentTrainCarAction}
            width={this.props.width}
            height={this.props.height}
            teamID={this.props.teamID}
            onHide={this.hideTrainCarRentBack.bind(this)}/>;
        let pathDetailsPopup = <PathDetailsWindow
            teamID={this.props.teamID}
            width={this.props.width}
            height={this.props.height}
            path={GameData.CurrentGame.getPathByID(this.state.PathDetailsInfo)}
            onHide={() => {
                this.setState({
                    PathDetailsInfo: null
                })
            }}
        />;
        let statistics = this.state.isShowStatistics && <StatisticsWindow
            onHide={this.hideStatistics.bind(this)}
            teamID={this.props.teamID}
        />;
        let gainsLosses = this.state.isShowGainsLosses && <GainsLossesReportWindow
            teamID={this.props.teamID}
            onHide={this.hideGainsLosses.bind(this)}/>;
        let tenders = <TendersPanel
            teamID={this.props.teamID}
            width={this.props.width}
            height={this.props.height}
            onHide={this.hideTenders.bind(this)}
        />
        let waitPopup = <GamePopup width={GameStyleUI.UserGameViewSize.width}
                                   height={GameStyleUI.UserGameViewSize.height}
                                   title={"Конец фазы"}
                                   message={"Дождитесь, пока преподаватель начнёт следующую фазу"}
        />;

        let stationInformation = this.state.isShowStationInformation && <StationInformation onHide={this.hideStationInformation.bind(this)}
                                                                                            station={this.state.currentStation}
                                                                                            openDictionaryAt={this.props.openDictionaryAt}/>;

        return <DndProvider backend={HTML5Backend}>
            <div style={{
                position: "relative", width: this.props.width, height: this.props.height,
            }}>
                <div id="pxrender" style={{position: "relative", zIndex: 0}}/>
                {this.initStationsUI()}
                {this.initPaths()}
                {this.initTopPanel()}
                {investPopup}
                {trainCarRentBackWindow}
                {this.state.SortStageStation ? this.getSortStagePopup(this.state.SortStageStation) : ""}
                {this.state.PathDetailsInfo ? pathDetailsPopup : ""}
                {this.state.trainCreateStation ? this.getTrainCreatePopup(this.state.trainCreateStation) : ""}
                {stationInformation}
                {this.state.isShowOrders ? this.getOrdersWindow() : ""}
                {this.state.isShowContracts && this.getContractsWindow()}
                {this.state.repairShop ? this.getRepairShopPopup(this.state.repairShop) : ""}

                {this.initBottomPanel()}
                {this.state.currentCards.length > 0 ? this.getCards() : ""}
                {this.state.isShowTenders ? tenders : ""}
                {balancePopup}
                {statistics}
                {gainsLosses}
                <Loader isActive={LoaderObject.isLoading}/>
                {GameData.CurrentGame.state < GameData.CurrentGame.teamState && this.isNotAdmin ? waitPopup : ""}
                {this.initBottomPanel()}
            </div>
        </DndProvider>
    }

}

export default Gameplay;
